// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"241":"796143ae","318":"714cedc0","520":"7f33055d","522":"469054d9"}[chunkId] + ".js";
};